import { render, staticRenderFns } from "./UpdateProfilePhoto.vue?vue&type=template&id=5f8608ca"
import script from "./UpdateProfilePhoto.vue?vue&type=script&lang=js"
export * from "./UpdateProfilePhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports